import { EDiagnosisStep } from '@/models/diagnosis';

export const TELEMEDICINE_REQUEST_HEADER_TITLES: Record<EDiagnosisStep, string> = {
  [EDiagnosisStep.Diagnosis]: '진료 신청서',
  [EDiagnosisStep.DoctorFilter]: '나에게 맞는 의사 찾기',
  [EDiagnosisStep.Doctor]: '의사 선택',
  [EDiagnosisStep.Payment]: '결제 정보 입력',
  [EDiagnosisStep.CertificationGuide]: '본인인증',
};
